import React, { useState } from 'react'
import { Icon } from '@iconify/react'

export default function Contrato() {
  return (
    <div style={{ padding: '24px' }}>
      <h1 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1e293b', marginBottom: '24px' }}>
        Contratos
      </h1>
      <div style={{ backgroundColor: 'white', padding: '24px', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
        <p style={{ color: '#64748b' }}>Gestão de contratos será implementada aqui.</p>
        <button style={{
          marginTop: '16px',
          backgroundColor: '#0891B2',
          color: 'white',
          border: 'none',
          padding: '10px 20px',
          borderRadius: '6px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <Icon icon="mdi:file-document-plus-outline" />
          Novo Contrato
        </button>
      </div>
    </div>
  )
}
